var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"微信支付","visible":_vm.dialogVisible,"width":"30%","before-close":_vm.handleClose,"destroy-on-close":""},on:{"update:visible":function($event){_vm.dialogVisible=$event},"open":_vm.open}},[_c('div',{attrs:{"id":"payQrcode"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6310cb4b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wxPay.vue
// module id = null
// module chunks = 